import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  HostBinding,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import {
  IWizView,
  PopUpManager,
  WizActionObj,
  WizComponentManager,
  WizPopUp,
  WizRoot,
  WizEventManager, WizEvent, WizTranslationManager
} from '@wizeoo/akm-component-lib';
import { AlkEvent, IWidgetFilter, LogoutCommand, MirrorFilters, PivotFilterExtendedRenderer, StyleEngine } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { RESOURCES } from 'src/assets/resources';
import { MenuPopUp } from './menu.pop';
import { KeycloakService } from 'keycloak-angular';
import { UserPopUp } from './user.pop';
import { VisionVO } from '@wizeoo/akm-compute-lib';
import { RouteEngine } from 'src/app/manager/routing/route.engine';

@Component({
  selector: 'menu-bar',
  templateUrl: './menu.bar.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationBar implements AfterViewInit {

  /** gestion dynamique de la couleur des barres */
  @HostBinding('style.background') get background() {
    if(Model.getInstance().currentVision?.color) {
      return Model.getInstance().currentVision?.color;
    } else {
      return StyleEngine.STYLE_DEFAULT_BAR_COLOR;
    }
  }
  

  // container HTML pour chargement des fonctions conditionnées
  @ViewChild('btnContainerConditional', {
    read: ViewContainerRef,
    static: true,
  })  btnContainerConditional: ViewContainerRef;

  // container HTML pour chargement des filtres globaux
  @ViewChild('containerFilter', { read: ViewContainerRef, static: false }) containerFilter: ViewContainerRef;

  /** drop de changement de vision */
  // @ViewChild('ddVision', { read: WizDropdown }) ddVision: WizDropdown;
  // @ViewChild('lblUser') lblUser: WizLabel;


  readonly LOGO_ME = RESOURCES.ALLKEYME; // logo AllkeyMe

  public burgerPop: WizPopUp = null; // popUp d'affichage du menu burger
  public userPop: WizPopUp = null; // popUp d'affichage du panel user

  constructor(public elRef: ElementRef, private security: KeycloakService, private _cdRef: ChangeDetectorRef) {}


  ngAfterViewInit() {
    // alimentation du user
    // WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.USER_LOADED, this.setUser);

    // sélection externe d'une vision
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.SELECT_VISION, this.setVision);

    // manipulation d'une vision (depuis la vue vision [visionVO, CUD])
    //WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.ALTER_VISION, this.alterVision);

    // écoute de la navigation (pour afficher les fonctions conditionnées par l'écran cible)
    WizEventManager.addListener(this, WizRoot.root(), WIZ_EVENT_TYPE.NAVIGATE_SET_VIEW, this.drawDynamics);
    
    WizEventManager.addListener(this, WizRoot.root(), WIZ_EVENT_TYPE.NAVIGATE_END, this.clearFilterDrops);

    // chargement du pool de visions éligibles pour le user (burger)
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.FEED_VISIONS, this.feed);

    // injection du filtre global dans la barre de menu
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.GLOBAL_FILTER_CLEAR, this.clearFilterDrops);
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.GLOBAL_FILTER_INJECT, this.feedFilter);

    // écoute en mode capture sur le changing, pour affichage éventuelle de popUp cancel si modif
    // WizEventManager.addListener(this, this.ddVision, WIZ_EVENT_TYPE.SELECTION_CHANGING, this.checkVisionChange, {
    //   capture: true,
    // });
    // // application du changement de vision par la dropdown
    // WizEventManager.addListener(this, this.ddVision, WIZ_EVENT_TYPE.SELECTION_CHANGED, this.updateVision);


    // fin chargement des trads
    // WizEventManager.addListener(this, WizRoot.root(),  WIZ_EVENT_TYPE.TRANSLATION_LOADED, this.setLocaleLoaded);



    setTimeout(() => {
      //this.setUser();
      this.feed();
    }, 0);
  }

  /**
   * les visions sont chargées
   * @param e 
   */
  public feed(e: AlkEvent = null): void {
    // console.log('menu feed visions', Model.getInstance().visionEngine.visionDS.getSource(), Model.getInstance().currentLocaleCode);
    //this.visionSource.setSource(Model.getInstance().visionEngine.visionDS.getSource()) ; 
  }

  /** sur alimentation du user, affichage de message de bienvenue */
  public setUser(): string {
    let res: string = '';
    if (Model.getInstance().connectedUser) {
      res = WizTranslationManager.getInstance().translateKey('$.account.hello.$', [
        Model.getInstance().connectedUser.fullName,
      ]);
    } 
    return res;
  }

  /**
   * synchro de la DS de la dropdown des visions et sélection de la vision active
   * @param e 
   */
  private setVision(e: AlkEvent = null): void {  
    const realVision: VisionVO = Model.getInstance().currentVision;

    if(!!realVision?.color) {
      // on en profite pour mettre à jour la couleur de fond
      document.documentElement.style.setProperty('--selected-tab-background', realVision.color);
      
      document.documentElement.style.setProperty('--selected-background-color', realVision.color);
      document.documentElement.style.setProperty('--focus-color', realVision.color);
      document.documentElement.style.setProperty('--item-purple', realVision.color);
      document.documentElement.style.setProperty('--grid-row-selected-background-color', realVision.color);
   
    }

    // this.visionSource.select([realVision]);
  }

  public filterComponents: ComponentRef<any>[]; // les champs de filtre

  /** suppression des combos de filtres (avant changement de step, ou sur retour de pop) */
  private clearFilterDrops(e: any = null): void {
    this.containerFilter?.clear(); // vider le container
    this.filterComponents = []; // on rince la référence aux filtres
  }


  /**
   * injection du filtre depuis la vue
   * TODO TODO détecter navigation sur vue sans filtre global && changement de vision
   * @param e 
   */
  public feedFilter(e: AlkEvent): void {
    // console.log('feedFilter', e);

    this.clearFilterDrops(); // on rince tout
    let mirror: MirrorFilters = e.data;
    if(!mirror || mirror.targetPlace !== 'MENU') {
      return;
    }

    // construire uniquement le rendu, pas besoin d'alimenter les collections tant que la drop n'est pas ouverte
    [...mirror.filters.values()].forEach((filter: IWidgetFilter) => {
      const meCompo: ComponentRef<any> = WizComponentManager.instance.addChildTo(
        PivotFilterExtendedRenderer,
        this.containerFilter,
        { instanceProperties: { data: filter } }
      );
      this.filterComponents.push(meCompo);
    });
    this._cdRef.markForCheck();
  }


  // création des instances de "boutons" conditionnés sur changement de vue
  drawDynamics(e: WizEvent = null) {
    // console.log('drawDynamics', e.value.title);

    
    const myView: IWizView = e.value; // la vue cible

    // this.lblTitle.wizLabel = e.value.title;  // alimentation du titre

    // this.btnContainerPanels.clear(); // vider le container de config IHM
    this.btnContainerConditional.clear(); // vider le container conditionnel

    if (myView.wizMainActions() != null) {
      // si une collection d'actions métier
      myView.wizMainActions().forEach((act: WizActionObj) => {
        // collecte
        WizComponentManager.instance.addChildTo(
          act.classFactory,
          this.btnContainerConditional,
          {
            instanceProperties: { data: act },
            styleProperties: { 'margin-right': '0px' },
          }
        );
      });
    }
  }


  /**
   * avant l'affichage de la pop, chargement de l'ensemble de MES visions
   * @param show 
   */
  public preShowBurger(show: boolean = true) {
  // if(!Model.getInstance().allVision) {
  //     new MyAppsCommand(Model.getInstance()).findAllVisions((cmd) => {
  //         // Model.getInstance().allVision = cmd.visions;
  //         this.showBurgerPop(show);
  //       }).execute();
  //     } else {
        this.showBurgerPop(show);
      // }
  }

  /**
   * affichage du menu burger
   * @param show : true pour afficher (défaut), false pour masquer
   */
  public showBurgerPop(show: boolean = true): void {
    if (PopUpManager.exist(this.burgerPop)) {
      // suppression de l'instance existante
      this.burgerPop.hide();
      return;
    }

    // construction unique de l'instance
    this.burgerPop = new WizPopUp(MenuPopUp, false, false, null, MenuPopUp.getWidth(), MenuPopUp.getHeight(), null, null, {
      left: '2px',
      top: '32px',
    });

    this.burgerPop.show();
  }

  public goUser(): void {
    if (PopUpManager.exist(this.userPop)) {
      // suppression de l'instance existante
      this.userPop.hide();
      return;
    }

    // construction unique de l'instance
    this.userPop = new WizPopUp(UserPopUp, false, false, null, '200px', '190px', null, null, {
      right: '30px',
      top: '32px',
    });
    
    this.userPop.show();
  }

  public askForLogout(): void {
    // Logout locale
    this.security.logout();
    // Logout serveur pour tuer la session spring security
    new LogoutCommand().execute();
  }

  /** forcer le rechargement des données (FD et BL) */
  public doRefresh(): void {
    Model.getInstance().compositeEngine.compositeReload(); 
  }

  /**
   * Evenement de click sur le profile, on navigue vers la vue du compte de l'utilisateur
   */
  public goToAccount(): void {
    Model.getInstance().navigationEngine.navigate(RouteEngine.FALLBACK_VIEW);
  }

}
